import { Component, HostBinding, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QaiLoadingComponent } from '@qai/ui';

@Component({
  imports: [CommonModule, QaiLoadingComponent],
  selector: 'app-pathway-call-main',
  standalone: true,
  styleUrls: ['./call-main.css'],
  templateUrl: './call-main.html',
})
export class PathwayCallMainComponent {
  isLoading = input(false);
  isPdf = input(false);

  @HostBinding('class')
  protected get cssClass() {
    return {
      isLoading: !!this.isLoading(),
      isPdf: !!this.isPdf(),
    };
  }
}
